import { Injectable } from '@angular/core';
import { OclGlobalInstructionTagService } from 'src/app/ocl/services/ocl-global-instruction-tag-service/ocl-global-instruction-tag.service';

@Injectable({
  providedIn: 'root',
})
export class OpsGlobalInstructionTagService extends OclGlobalInstructionTagService {
  // tslint:disable:variable-name
  protected ParseGlobalInstructionTag = Parse.Object.extend('OPSGlobalInstructionTag');
  protected ParseGlobalInstruction = Parse.Object.extend('OPSGlobalInstruction');
  protected ParseTag = Parse.Object.extend('OPSTag');
  // tslint:enable
}
